"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var basic_required_1 = require("./basic-required");
exports.ImmutableBasicRequiredDefinition = basic_required_1.ImmutableBasicRequiredDefinition;
var some_required_1 = require("./some-required");
exports.ImmutableSomeRequiredDefinition = some_required_1.ImmutableSomeRequiredDefinition;
var form_constants_1 = require("../../form-constants");
/**
 * converts a non-immutable definition of a required definition, and converts it into an immutable definition
 * @param definition the non-immutable definition
 */
function convertToImmutable(definition) {
    if (!definition)
        return null;
    switch (definition.type) {
        case form_constants_1.requireType.ALL:
        case form_constants_1.requireType.ANY: return new basic_required_1.ImmutableBasicRequiredDefinition(definition);
        case form_constants_1.requireType.SOME: return new some_required_1.ImmutableSomeRequiredDefinition(definition);
        default: return null;
    }
}
exports.convertToImmutable = convertToImmutable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/required-definition/index.js
// module id = 1132
// module chunks = 0